import { render, staticRenderFns } from "./TransferProduct.vue?vue&type=template&id=770e40e4"
import script from "./TransferProduct.vue?vue&type=script&lang=js"
export * from "./TransferProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports